import * as types from "./labels.type";
import api from "../../../../services/api";

const labelsRequest = () => {
  return { type: types.LABELS_REQUEST };
};

const labelsFailure = (error) => {
  return (dispatch) => dispatch({ type: types.LABELS_FAILURE, payload: error });
};

const labelsSuccess = (response) => {
  return (dispatch) =>
    dispatch({ type: types.LABELS_SUCCESS, payload: response });
};

export const resetLabelOrderForm = () => {
  return { type: types.RESET_LABEL_ORDER_FORM };
};

export const selectLabel = (data, isSelected) => {
  return (dispatch) =>
    dispatch({ type: types.SELECT_LABEL, payload: { data, isSelected } });
};

export const selectAllLabels = (isSelectedAll) => {
  return (dispatch) =>
    dispatch({ type: types.TOGGLE_ALL_LABELS, payload: { isSelectedAll } });
};

export const setQuantity = (data, quantity) => {
  return (dispatch) =>
    dispatch({ type: types.SET_QUANTITY, payload: { data, quantity } });
};

export const setOnblurQuantity = (data, quantity) => {
  return (dispatch) =>
    dispatch({ type: types.SET_ONBLUR_QUANTITY, payload: { data, quantity } });
};

export const setUnitOfMeasurement = (data, uom) => {
  return (dispatch) =>
    dispatch({ type: types.SET_UNIT_OF_MEASUREMENT, payload: { data, uom } });
};

export const removeCartItems = (cartItemIds) => {
  return (dispatch) =>
    dispatch({
      type: types.MANUFACTURER_STANDARD_LABEL_ITEMS_REMOVE,
      payload: { cartItemIds }
    });
};

export const getLabels = (
  labelOrderCartId,
  ccn,
  manufacturerId,
  fileNumber,
  ccnList,
  fileNumberList,
  volume,
  volumeList,
  accountNumber,
  isCopied
) => {
  return async (dispatch) => {
    dispatch(labelsRequest());
    const result = await api.Manufacturer.getLabels(
      labelOrderCartId,
      ccn,
      manufacturerId,
      fileNumber,
      ccnList,
      fileNumberList,
      volume,
      volumeList,
      accountNumber,
      isCopied
    );

    if (result) {
      dispatch(labelsSuccess(result));
    } else {
      dispatch(labelsFailure("Something went wrong."));
    }
  };
};

const addToCartRequest = () => {
  return { type: types.ADD_TO_CART_REQUEST };
};

const addToCartFailure = (error) => {
  return (dispatch) =>
    dispatch({ type: types.ADD_TO_CART_FAILURE, payload: error });
};

const addToCartSuccess = (response) => {
  return (dispatch) =>
    dispatch({ type: types.ADD_TO_CART_SUCCESS, payload: response });
};

export const resetAddToCart = () => {
  return { type: types.ADD_TO_CART_RESET };
};

export const addToCart = (cartData) => {
  return async (dispatch) => {
    dispatch(addToCartRequest());
    const result = await api.Manufacturer.addToCart(cartData);

    if (result) {
      dispatch(addToCartSuccess(result));
      return result;
    } else {
      dispatch(addToCartFailure("Something went wrong."));
    }
  };
};

const checkIfOrderExceedRequest = () => {
  return { type: types.CHECK_EXCEED_REQUEST };
};

const checkIfOrderExceedFailure = (error) => {
  return (dispatch) =>
    dispatch({ type: types.CHECK_EXCEED_FAILURE, payload: error });
};

const checkIfOrderExceedSuccess = (response) => {
  return (dispatch) =>
    dispatch({ type: types.CHECK_EXCEED_SUCCESS, payload: response });
};

export const checkIfLabelExceed = (data) => {
  return async (dispatch) => {

    dispatch(checkIfOrderExceedRequest());
    const result = await api.Manufacturer.checkIfLabelExceed(data);

    if (result) {
      dispatch(checkIfOrderExceedSuccess(result));
      return result;
    } else {
      dispatch(checkIfOrderExceedFailure("Something went wrong."));
    }
  };
};

const checkIfOrderExceedCombinationRequest = () => {
  return { type: types.CHECK_EXCEED_REQUEST_COMBINATION };
};

const checkIfOrderExceedCombinationFailure = (error) => {
  return (dispatch) =>
    dispatch({ type: types.CHECK_EXCEED_FAILURE_COMBINATION, payload: error });
};

const checkIfOrderExceedCombinationSuccess = (response) => {
  return (dispatch) =>
    dispatch({ type: types.CHECK_EXCEED_SUCCESS_COMBINATION, payload: response });
};

export const checkIfLabelExceedCombination = (data) => {
  return async (dispatch) => {

    dispatch(checkIfOrderExceedCombinationRequest());
    const result = await api.Manufacturer.checkIfLabelExceedCombination(data);

    if (result) {
      dispatch(checkIfOrderExceedCombinationSuccess(result));
      return result;
    } else {
      dispatch(checkIfOrderExceedCombinationFailure("Something went wrong."));
    }
  };
};

export const highLightExceed = (response) => {
  return (dispatch) =>
    dispatch({ type: types.HIGHLIGHT_EXCEED, payload: response });
};